import { Component, Inject } from '@angular/core';
import { PartnersService } from './partners.service';
import { PartnersListComponent } from './partners-list.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-partners-dialog-delete',
    templateUrl: './partners-dialog-delete.component.html',
    styleUrls: ['./partners-dialog-delete.component.css'],
    standalone: false
})
export class PartnersDialogDeleteComponent  {

  uid: number = this.data.uid;
  type: string = this.data.type;
  error_msg: string;
  error: boolean = false;

  constructor(
    public partnersService: PartnersService,
    public dialogRef: MatDialogRef<PartnersListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  delete() {
    this.partnersService.deleteData(this.uid);
    this.error = true;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
